import React from "react";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";

function EmpWelcomeBanner() {
  const { empInfo } = useEmployeeData();

  return (
    <div className="welcome-banner animate-in">
      <div className="welcome-content">
        <div className="welcome-greeting">Hey {empInfo.name}, welcome back! 👋</div>
        <div className="welcome-subtitle">{empInfo.role} · {empInfo.team}</div>
        <div className="welcome-badges">
          <span className="welcome-badge verified"><Icons.Shield /> Verified</span>
          <span className="welcome-badge">📅 Joined {empInfo.startDate}</span>
          <span className="welcome-badge">👤 {empInfo.manager}</span>
          <span className="welcome-badge">📍 {empInfo.location}</span>
        </div>
      </div>
      <div className="id-badge">{empInfo.id}</div>
    </div>
  );
}

export default EmpWelcomeBanner;
